(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-deferred-video')) {
    customElements.define('lp-deferred-video', class extends HTMLElement {
      connectedCallback() {
        this.handleActivation ||= event => {
          if (!event.target.closest('.lp-iwt-play') || this.failed) return;
          event.preventDefault();
          this.userRequested = true;
          this.loadVideo(true);
        };
        this.addEventListener('click', this.handleActivation);
        if (this.video || this.observer || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadVideo(false);
        }, { rootMargin: '0px', threshold: 0.01 });
        this.observer.observe(this);
      }
      loadVideo(userInitiated) {
        this.observer?.disconnect();
        this.observer = null;
        if (!this.video) {
          const template = this.querySelector('template');
          if (!template) return;
          const fragment = template.content.cloneNode(true);
          this.video = fragment.querySelector('video');
          if (!this.video) return;
          this.video.controls = true;
          this.video.preload = 'auto';
          this.video.tabIndex = 0;
          this.video.addEventListener('loadeddata', () => {
            this.setAttribute('data-loaded', '');
            if (this.userRequested) this.video.focus({ preventScroll: true });
          }, { once: true });
          this.video.addEventListener('error', () => {
            this.failed = true;
            this.removeAttribute('data-loaded');
          }, { once: true });
          this.appendChild(fragment);
          template.remove();
          this.video.load();
        }
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (userInitiated || (this.dataset.autoplay === 'true' && !reducedMotion)) {
          const playback = this.video.play();
          if (playback) playback.catch(() => {});
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.removeEventListener('click', this.handleActivation);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
